import { supabase } from "@/integrations/supabase/client";
import { UserProfile, AppRole } from "@/types/database/auth";

export const useUserProfileData = () => {
  const fetchUserProfile = async (userId: string) => {
    console.log("Fetching profile for user:", userId);

    const { data: profileData, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (profileError) {
      console.error("Error fetching profile:", profileError);
      throw profileError;
    }

    const { data: roleData, error: roleError } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .limit(1)
      .single();
    
    if (roleError) {
      console.error("Error fetching roles:", roleError);
      throw roleError;
    }

    console.log("Found role:", roleData);

    const profile: UserProfile = {
      ...profileData,
      role: (roleData?.role as AppRole) || 'user'
    };

    return profile;
  };

  return { fetchUserProfile };
};